function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "logo--type-path",
  d: "M19.8,4.1H1.9C0.9,4.1,0,3.3,0,2.2s0.9-1.9,1.9-1.9h39.9c1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9H23.9v50.2 c0,1.1-1,2.1-2.1,2.1c-1.1,0-2.1-1-2.1-2.1V4.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "logo--type-path",
  d: "M56,2.4c0-1.1,1-2.1,2.1-2.1h21.4c6.9,0,12.4,2.2,15.7,5.5c2.6,2.6,4.2,6.4,4.2,10.4v0.2 c0,9.3-6.9,14.7-16.3,15.9l15.9,20.6c0.4,0.5,0.6,1,0.6,1.4c0,1.1-1,2.2-2.2,2.2c-0.8,0-1.4-0.5-1.8-1.1L78.4,33H60.1v21.4 c0,1.1-1,2.1-2.1,2.1c-1.1,0-2.1-1-2.1-2.1V2.4z M78.9,29.3c9.3,0,16.3-4.7,16.3-12.8v-0.2c0-7.5-5.9-12.2-16-12.2H60.1v25.1H78.9z "
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "logo--type-path",
  d: "M114.2,2.1c0-1.1,1-2.1,2.1-2.1s2.1,1,2.1,2.1v52.3c0,1.1-1,2.1-2.1,2.1s-2.1-1-2.1-2.1V2.1z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "logo--type-path",
  d: "M154.5,54.9l-22.7-52c-0.2-0.3-0.2-0.5-0.2-0.9c0-1,0.9-2,2.1-2c1,0,1.8,0.7,2.2,1.7l21.3,50l21.4-50.1 c0.4-0.9,1.1-1.6,2.1-1.6c1.1,0,2,1,2,1.9c0,0.3,0,0.5-0.2,0.8l-22.8,52.1c-0.5,1.1-1.2,1.8-2.5,1.8H157 C155.7,56.7,155,56,154.5,54.9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "logo--type-path",
  d: "M195.3,54.1V2.4c0-1.1,1-2.1,2.1-2.1h36c1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9h-34v21.9h30.4 c1,0,1.9,0.9,1.9,1.9c0,1-0.9,1.9-1.9,1.9h-30.4v22.4h34.4c1,0,1.9,0.9,1.9,1.9c0,1-0.9,1.9-1.9,1.9h-36.4 C196.2,56.1,195.3,55.2,195.3,54.1z"
});

var SvgLogoTextPlain = function SvgLogoTextPlain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.7 56.7",
    style: {
      enableBackground: "new 0 0 235.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoTextPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo--text-plain.ba9757de.svg";
export { ForwardRef as ReactComponent };